export default __webpack_public_path__ + "static/media/cartempty.b342317c.svg";